import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert,
  FormHelperText,
  Divider,
} from "@mui/material";
import {
  Close,
  CalendarToday,
  Schedule,
  LocationOn,
  Add,
  Remove,
} from "@mui/icons-material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import useAxios from "../../useAxios";
import axios from "axios";
import {
  removeFromCart,
  updateQuantity,
  clearCart,
  setCart,
  addToCart,
} from "../../redux/slices/cartSlice";
const BookingForm = ({ open, onClose, selectedProduct,totalPrice, userDetails }) => {
  const [loading, setLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [productsGet, setProductGet] = useState([]);
  const [activityOptions, setActivityOptions] = useState([]);
  const [timeOptions, setTimeOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [activityAreaOptions, setActivityAreaOptions] = useState([]);
  const [product, setProduct] = useState(selectedProduct);
  const axiosData = useAxios();
  const dispatch = useDispatch();
  // Form state
  const [formData, setFormData] = useState({
    contactNumber: "",
    companyName: "",
    city: "",
    date: null,
    startDate: null,
    endDate: null,
    isMultiDay: false,
    otherCity: "",
    startTime: "",
    endTime: "",
    venueName: "",
    activityArea: "",
    products: productsGet,
    quantity: "",
    pointOfContact: "",
    requirements: "",
    staff: "",
    activityType: "",
    reportingTime: "",
    venueMapLink: "",
    totalPrice:""
  });
  // Form validation errors
  const [errors, setErrors] = useState({});
  function normalize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "")   // remove special chars
    .replace(/\s+/g, " ")         // collapse spaces
    .trim();
}
function similarity(a, b) {
  const A = normalize(a).split(" ");
  const B = normalize(b).split(" ");

  let matches = 0;

  A.forEach(wordA => {
    B.forEach(wordB => {
      if (wordA && wordB && wordA === wordB) {
        matches++;
      }
    });
  });

  return (matches / Math.max(A.length, B.length)) * 100;
}
function autoMatchProduct(frontValue, productOptions,productDatas,index) {
  if (!frontValue) return { id: null, description: null };
  let bestMatch = null;
  let bestScore = 0;
if(productDatas.category === "VR Games" ){
    const vrItem = productOptions.find((data) => data.label === "VR Gaming");
      setFormData(prev => {
      const updatedProducts = [...prev.products];
      updatedProducts[index] = {
        ...updatedProducts[index],
        product: vrItem?.label || updatedProducts[index].product,
        productId: vrItem?.id || updatedProducts[index].productId
      };
      return { ...prev, products: updatedProducts };
    });
    return {
      id: vrItem?.id || null,
      description: `${productDatas.category} - ${frontValue}`, // send requirement to append
    };
  }
  if(productDatas.category === "AR Games"){
 const arItem = productOptions.find((data) => data.label === "AR Games");
  // Update formData.products directly
    setFormData(prev => {
      const updatedProducts = [...prev.products];
      updatedProducts[index] = {
        ...updatedProducts[index],
        product: arItem?.label || updatedProducts[index].product,
        productId: arItem?.id || updatedProducts[index].productId
      };
      return { ...prev, products: updatedProducts };
    });   
 return {
      id: arItem?.id || null,
      description: `${productDatas.category} - ${frontValue}`,
    };
  }
 productOptions.forEach((backend) => {
    const score = similarity(frontValue, backend.label);

    if (score > bestScore) {
      bestScore = score;
      bestMatch = backend.id;
    }
  });
   if (!bestMatch || bestScore < 70) {
    const fallback = productOptions.find(
      (data) => data.label.trim().toLowerCase().includes(productDatas.category.trim().toLowerCase())
    );
     setFormData(prev => {
      const updatedProducts = [...prev.products];
      updatedProducts[index] = {
        ...updatedProducts[index],
        product: fallback?.label || updatedProducts[index].product,
        productId: fallback?.id || updatedProducts[index].productId
      };
      return { ...prev, products: updatedProducts };
    });
    return {
      id: fallback?.id || null,
      description: `${productDatas.category} - ${frontValue}`, // do not update requirement
    };
  }

  return {
    id: bestMatch,
    description: "", // do not update requirement
  };
}
  // Time options
  // const timeOptions = [
  //   "12:00 AM",
  //   "12:30 AM",
  //   "1:00 AM",
  //   "1:30 AM",
  //   "2:00 AM",
  //   "2:30 AM",
  //   "3:00 AM",
  //   "3:30 AM",
  //   "4:00 AM",
  //   "4:30 AM",
  //   "5:00 AM",
  //   "5:30 AM",
  //   "6:00 AM",
  //   "6:30 AM",
  //   "7:00 AM",
  //   "7:30 AM",
  //   "8:00 AM",
  //   "8:30 AM",
  //   "9:00 AM",
  //   "9:30 AM",
  //   "10:00 AM",
  //   "10:30 AM",
  //   "11:00 AM",
  //   "11:30 AM",
  //   "12:00 PM",
  //   "12:30 PM",
  //   "1:00 PM",
  //   "1:30 PM",
  //   "2:00 PM",
  //   "2:30 PM",
  //   "3:00 PM",
  //   "3:30 PM",
  //   "4:00 PM",
  //   "4:30 PM",
  //   "5:00 PM",
  //   "5:30 PM",
  //   "6:00 PM",
  //   "6:30 PM",
  //   "7:00 PM",
  //   "7:30 PM",
  //   "8:00 PM",
  //   "8:30 PM",
  //   "9:00 PM",
  //   "9:30 PM",
  //   "10:00 PM",
  //   "10:30 PM",
  //   "11:00 PM",
  //   "11:30 PM",
  // ];
  // const productOptions = [
  //   { value: "360-Degree Rotation Booth", label: "360 Video Booth" },
  //   { value: "Mirror Photo Booth", label: "Mirror Photobooth" },
  //   { value: "AR Photo Booth", label: "AR Photobooth" },
  //   { value: "VR Gaming", label: "VR Gaming" },
  //   { value: "Green Screen Photo Booth", label: "Green Screen Photo booth" },
  //   { value: "Instant Photo Booth (DSLR)", label: "Instant Photo Prints" },
  //   { value: "Word Cloud Photo Booth", label: "Word Cloud Photo booth" },
  //   {
  //     value: "Digital Caricature Photobooth",
  //     label: "Digital Caricature Photobooth",
  //   },
  //   { value: "Bobble Head Photo Booth", label: "Bobble Head Photo Booth" },
  //   {
  //     value: "Interactive Cycle Activity",
  //     label: "Interactive Cycle Activity",
  //   },
  //   { value: "AI Photo Booth (IPad)", label: "AI Photo Booth" },
  //   { value: "Digital Slingshot", label: "Digital Slingshot" },
  //   { value: "Neuro Sensor Car Game", label: "Neurosensor Car Game" },
  //   { value: "Flip Book Photo Booth", label: "FlipBook Photobooth" },
  //   { value: "Selfie Photobooth", label: "Selfie Photobooth" },
  //   { value: "Clone Photo Booth", label: "Clone Photo booth" },
  //   { value: "Prism Photo Booth", label: "Prism Photo booth" },
  //   { value: "Magazine Photo Booth", label: "Magazine Photo booth" },
  //   { value: "Anti-Gravity Photo Booth", label: "Anti Gravity Photo booth" },
  //   { value: "Memory Game", label: "Memory Game" },
  //   { value: "Jigsaw Puzzle", label: "JigSaw Puzzle" },
  //   { value: "Spin Wheel", label: "Spinwheel" },
  //   { value: "Glambot", label: "Glambot Photobooth" },
  //   { value: "QR Code Registration", label: "QR Code Registration" },
  //   { value: "Video Feedback", label: "Video Feedback" },
  //   { value: "Strip Photo Booth", label: "Strip Photo booth" },
  //   { value: "GIF Booth", label: "GIF Photo booth" },
  //   { value: "IPad Photo Booth", label: "Ipad Photo booth" },
  //   { value: "AR Games", label: "AR Games" },
  //   { value: "Hashtag Printer Photo Booth", label: "Hashtag Printer" },
  //   { value: "Digital Mosaic Wall", label: "Digital Mosaic Wall" },
  //   { value: "Physical Mosaic Wall", label: "Physical Mosaic Wall" },
  //   { value: "Customised Batak Pro", label: "Batak Pro" },
  //   { value: "Time Freeze Photobooth", label: "Time Freeze Photobooth" },
  //   { value: "Mirror - Digital QR Booth", label: "QR Code Mirror Photobooth" },
  //   { value: "Audio Guest Book", label: "Audio Guest Book" },
  //   {
  //     value: "Touch Screen Activity - Application",
  //     label: "Touch Screen Activity - Application",
  //   },
  //   {
  //     value: "Selfie Photo Booth -QR Code",
  //     label: "Selfie Photo Booth -QR Code",
  //   },
  //   { value: "Physical Photo Frames", label: "Physical Photo Frames" },
  //   { value: "Chroma Key Video Booth", label: "Chroma Key Video Booth" },
  //   { value: "Catch the Batton", label: "Catch the Batton" },
  //   { value: "Social Wall", label: "Social Wall" },
  //   { value: "Move N' Pick", label: "Move N' Pick" },
  //   { value: "Physical Selfie Stand", label: "Physical Selfie Stand" },
  //   { value: "Photography & Videography", label: "Photography & Videography" },
  //   { value: "Other Services", label: "Other Services" },
  //   { value: "AI Video Booth", label: "AI Video Booth" },
  //   {
  //     value: "Light Painting Photo Booth",
  //     label: "Light Painting Photo booth",
  //   },
  //   { value: "Quiz Game", label: "Quiz Game with Touch Screen" },
  //   { value: "Jungle Run", label: "Jungle Run" },
  //   { value: "Pot Breaking", label: "Pot Breaking" },
  //   { value: "AI QR Code", label: "AI QR Code" },
  //   { value: "AI Face Swap Photo Booth (TV)", label: "AI Face Swap" },
  //   { value: "Vogue Light Slomo Booth", label: "Vogue - Slowmo Video Booth" },
  //   { value: "AI Background Removal", label: "AI Background Removal" },
  //   { value: "RFID Registration", label: "RFID Registration" },
  //   { value: "Strip-iPad Photo Booth", label: "Strip-iPad Photo Booth" },
  //   { value: "BagTag Photo Booth", label: "BAGTAG" },
  //   {
  //     value: "A4 Calendar with Caricature",
  //     label: "A4 Calendar with Caricature",
  //   },
  //   {
  //     value: "Customized Software Solutions",
  //     label: "Customized Software Solutions",
  //   },
  //   { value: "Interactive Stepper Activity", label: "Stepper Actvity" },
  //   { value: "Cardboard Frames", label: "Cardboard Frames" },
  //   { value: "Think Bubble", label: "AI Think Bubble" },
  //   { value: "Lenticular Photo Booth", label: "Lenticular Photo Booth" },
  //   { value: "Photo Booth Software", label: "Photo Booth Software" },
  //   { value: "Wooden Frames", label: "Wooden Frames" },
  //   { value: "Gibhli Photo Booth", label: "Ghibli Photo Booth" },
  //   { value: "AI Sketch Bot", label: "Sketch bot" },
  //   {
  //     value: "AI 360-Degree Rotation Booth",
  //     label: "AI 360-Degree Video Booth",
  //   },
  //   { value: "Ai face recognition", label: "Ai face recognition" },
  //   { value: "Software Development", label: "Software Development" },
  //   { value: "Software Support", label: "Software Support" },
  //   { value: "AI Photo Sharing", label: "AI Photo Sharing" },
  //   { value: "Photo Booths", label: "Photo Booths" },
  //   { value: "Carnival Games", label: "Carnival Games" },
  //   { value: "QR Selfie - Mosaic Wall", label: "QR Selfie Mosaic Wall" },
  //   { value: "Digi Globe Mosaic Wall", label: "Digi Globe Mosaic Wall" },
  //   { value: "Scream Challenge  Excito Meter", label: "Scream Challenge" },

  //   { value: "Caricature Photo Booth", label: "Caricature Photo Booth" },
  //   { value: "Calender Photo Booth", label: "Calender Photo Booth" },
  //   {
  //     value: "Signature Analyser Photo Booth",
  //     label: "Signature Analyser Photo Booth",
  //   },
  //   { value: "Bullet Time Freeze", label: "Bullet Time Freeze" },
  //   { value: "Boomerang Booth", label: "Boomerang Booth" },
  //   { value: "Review Booth", label: "Review Booth" },
  //   { value: "Feedback Wall", label: "Feedback Wall" },
  //   { value: "Pick and Play", label: "Pick and Play" },
  //   {
  //     value: "Digital Mind Control Car Game",
  //     label: "Digital Mind Control Car Game",
  //   },
  //   { value: "Digital Uriyadi", label: "Digital Uriyadi" },
  //   { value: "Fill the Basket", label: "Fill the Basket" },
  //   { value: "Connecting Dots", label: "Connecting Dots" },
  //   { value: "Crossword Puzzle", label: "Crossword Puzzle" },
  //   { value: "Nutri Blocks", label: "Nutri Blocks" },
  //   { value: "Matching Pairs", label: "Matching Pairs" },
  //   { value: "Number Guess", label: "Number Guess" },
  //   { value: "TIC TAC TOE", label: "TIC TAC TOE" },
  //   { value: "Slider Puzzle", label: "Slider Puzzle" },
  //   { value: "VR - Cricket", label: "VR - Cricket" },
  //   { value: "Richie Plank", label: "Richie Plank" },
  //   { value: "Fruit Ninja", label: "Fruit Ninja" },
  //   { value: "Beat Saber", label: "Beat Saber" },
  //   {
  //     value: "Bullet Train (Shooting Game)",
  //     label: "Bullet Train (Shooting Game)",
  //   },
  //   { value: "Table Tennis", label: "Table Tennis" },
  //   { value: "Boxing Game", label: "Boxing Game" },
  //   { value: "Golf", label: "Golf" },
  //   {
  //     value: "Five Nights & Freddy's (Horrer)",
  //     label: "Five Nights & Freddy's (Horrer)",
  //   },
  //   {
  //     value: "Wraith (Horrer - Shooting Game)",
  //     label: "Wraith (Horrer - Shooting Game)",
  //   },
  //   { value: "Grid Legent (Car Race)", label: "Grid Legent (Car Race)" },
  //   { value: "Epic Roller Coaster", label: "Epic Roller Coaster" },
  //   { value: "Desert Ride", label: "Desert Ride" },
  //   {
  //     value: "Invasion (Animated Experience)",
  //     label: "Invasion (Animated Experience)",
  //   },
  //   { value: "The Blu (Under the Sea)", label: "The Blu (Under the Sea)" },
  //   { value: "Oculus Dreamdeck", label: "Oculus Dreamdeck" },
  //   { value: "Climbing Experience", label: "Climbing Experience" },
  //   { value: "Bungee Jumping (For Kids)", label: "Bungee Jumping (For Kids)" },
  //   { value: "Gaint Wheel Rider", label: "Gaint Wheel Rider" },
  //   { value: "Jurassic World (For Kids)", label: "Jurassic World (For Kids)" },
  //   { value: "Memory Game-Virtual", label: "Memory Game-Virtual" },
  //   { value: "Jigsaw Puzzle-Virtual", label: "Jigsaw Puzzle-Virtual" },
  //   { value: "Quiz Game-Virtual", label: "Quiz Game-Virtual" },
  //   { value: "Spin Wheel-Virtual", label: "Spin Wheel-Virtual" },
  //   { value: "Connecting Dots-Virtual", label: "Connecting Dots-Virtual" },
  //   { value: "Crossword Puzzle-Virtual", label: "Crossword Puzzle-Virtual" },
  //   { value: "Nutri Blocks-Virtual", label: "Nutri Blocks-Virtual" },
  //   {
  //     value: "Match The Following-Virtual",
  //     label: "Match The Following-Virtual",
  //   },
  //   { value: "Number Guess-Virtual", label: "Number Guess-Virtual" },
  //   { value: "TIC TAC TOE-Virtual", label: "TIC TAC TOE-Virtual" },
  //   { value: "Slider Puzzle-Virtual", label: "Slider Puzzle-Virtual" },

  //   //New Product List
  //   { value: "VR - Archery", label: "VR - Archery" },
  //   { value: "Escape Room", label: "Escape Room" },
  //   { value: "VR - Cricketuriy", label: "VR - Cricketuriy" },
  //   { value: "Excitement Meter", label: "Excitement Meter" },
  //   { value: "Speed Surge", label: "Speed Surge" },
  //   { value: "AR Cricket", label: "AR Cricket" },
  //   { value: "Digi Globe Mosaic Wall", label: "Digi Globe Mosaic Wall" },
  //   { value: "Animated Video Booth", label: "Animated Video Booth" },
  //   { value: "Animated Photo Booth", label: "Animated Photo Booth" },
  //   { value: "Fridge Magnet Photo Booth", label: "Fridge Magnet Photo Booth" },
  //   { value: "Robotic Photo Booth", label: "Robotic Photo Booth" },
  // ];
  useEffect(() => {
    setProduct(selectedProduct);
  }, [selectedProduct]);

  useEffect(() => {
    const saved = localStorage.getItem("cart");
    if (saved) {
      const getlocalcart = JSON.parse(saved);
      const data =
        product && product.length > 0
          ? product.map((p) => ({
              product: p.name, // normalize to `product`
              quantity: p.quantity,
              category: p.category,
              price: p.price,
            }))
          : getlocalcart.length > 0
          ? getlocalcart.map((p) => ({
              product: p.name || p.product, // handle both `name` or `product`
              quantity: p.quantity,
              category: p.category,
              price: p.price,
            }))
          : [{ product: "", quantity: "" }];

      setProductGet(data);
      setFormData((prev) => ({
        ...prev,
        products: data,
      }));
    }
    fetchCRMinputs()
    //loadCartFromDB();
  }, []);
  const loadCartFromDB = async () => {
    try {
      const storedAuth = localStorage.getItem("auth");
      if (storedAuth) {
        const parsed = JSON.parse(storedAuth);
        const response = await axiosData.get(`getCartData/${parsed.email}`);
        if (response.data && response.data.cart.items) {
          product = response.data.cart.items;
          //dispatch(setCart(dataGet));
          // const storeData =dataGet.map((data)=>{
          //    dispatch(setCart(data));
          // })
        }
      }
    } catch (err) {
      console.error("Error loading cart from database", err);
    }
  };
  // Pre-fill form with user details when opened
  useEffect(() => {
    if (open && userDetails) {
      setFormData((prev) => ({
        ...prev,
        contactNumber: userDetails.mobile_number || "",
        companyName: userDetails.company_name || "",
        city: userDetails.city || "Select City",
        pointOfContact: userDetails.name || "",
        totalPrice: totalPrice || "",
        //      products:  product
        // ? [{ product: product.name, quantity: product.quantity }]
        // : [{ product: "", quantity: "" }],
      }));
    }
  }, [open, userDetails, product]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when field is updated
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const handleDateChange = (date) => {
    setFormData((prev) => ({ ...prev, date }));

    // Clear error when field is updated
    if (errors.date) {
      setErrors((prev) => ({ ...prev, date: "" }));
    }
  };
const bookMessageSend = async (email,mobile,eventDateValue,eventTimeValue,locationValue,cityValue) => {
    try {
      // Simulate API call for password reset
      const response = await axiosData.put(`getUser/bookmessage/${email}`, {
      mobile_number: parseInt(mobile),
      event_date:eventDateValue,
      event_time:eventTimeValue,
      location:locationValue,
      city:cityValue
      });
      if (response) {
        // console.log("message send")
      }
    } catch (err) {
      console.error(err)
    } finally {
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.contactNumber)
      newErrors.contactNumber = "Contact number is required";
    if (!formData.companyName)
      newErrors.companyName = "Company name is required";
    if (formData.city === "other" && !formData.otherCity)
      newErrors.otherCity = "Please enter city";
    if (!formData.isMultiDay && !formData.date)
      newErrors.date = "Date is required";
    if (formData.isMultiDay) {
      if (!formData.startDate) newErrors.startDate = "Start date is required";
      if (!formData.endDate) newErrors.endDate = "End date is required";
    }
    if (!formData.startTime) newErrors.startTime = "Start time is required";
    if (!formData.endTime) newErrors.endTime = "End time is required";
    if (!formData.venueName) newErrors.venueName = "Venue name is required";
    if (!formData.activityArea)
      newErrors.activityArea = "Activity area is required";
    formData.products.forEach((p, i) => {
      if (!p.product)
        newErrors[`products.${i}.product`] = "Product is required";
      if (!p.quantity)
        newErrors[`products.${i}.quantity`] = "Quantity is required";
    });
    if (!formData.pointOfContact)
      newErrors.pointOfContact = "Point of contact is required";
    // if (!formData.staff) newErrors.staff = "Staff selection is required";
    if (!formData.activityType)
      newErrors.activityType = "Activity type is required";
    if (!formData.reportingTime)
      newErrors.reportingTime = "Reporting time is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  //format timing
  function timeToSeconds(timeStr) {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
    const timefinal = hours * 3600 + minutes * 60;
    return parseInt(timefinal); // seconds since midnight
  }
useEffect(() => {
  if (!productOptions.length || !formData.products?.length) return;

  const updatedProducts = formData.products.map((prod,index) => {
    const result = autoMatchProduct(prod.product, productOptions, prod,index);
    const matched = productOptions.find(opt => opt.id === result.id);
    return {
      ...prod,
      product: matched?.label || prod.product,
      productId: matched?.id || prod.productId,
      description: result.description || prod.description
    };
  });

  setFormData(prev => ({ ...prev, products: updatedProducts }));
}, [productOptions]);

  // Handle product/quantity changes
  // const handleProductChange = (index, e) => {
  //   const { value } = e.target;
  //    const selectedLabel = e.target.value;
  //   // ? Get label by finding the selected option
  //   const selectedOption = productOptions.find((opt) => opt.value === value);
  //   const label = selectedOption?.label || value;
  //   const updatedProducts = [...formData.products];
  //   // updatedProducts[index][label] = value;
  //   updatedProducts[index].product = value;
  //   setFormData((prev) => ({ ...prev, products: updatedProducts }));
  //   // clear error
  //   if (errors[`products.${index}.${label}`]) {
  //     setErrors((prev) => ({ ...prev, [`products.${index}.${label}`]: "" }));
  //   }
  // };
const handleProductChange = (index, e) => {
  const { name, value } = e.target;  // backend.id
 // const selectedOption = productOptions.find(opt => opt.id  === value);
  const updatedProducts = [...formData.products];
 if (name === "quantity") {
    // update quantity directly
    updatedProducts[index] = {
      ...updatedProducts[index],
      quantity: Number(value), // ensure it's a number
    };
  } else if (name === "product") {
      const selectedOption = productOptions.find(opt => opt.id === value); // find by id
  updatedProducts[index] = {
    ...updatedProducts[index],
    product: selectedOption?.label || "",   // Save backend label (CRM)
    productId: selectedOption?.id || "",    // Save backend id
    // amount: selectedOption?.amount || "",   // Save backend amount (optional)
  };
  }
  setFormData(prev => ({ ...prev, products: updatedProducts }));

  // clear error
  if (errors[`products.${index}.product`]) {
    setErrors(prev => ({ ...prev, [`products.${index}.product`]: "" }));
  }
};
  // Add new row
  const handleAddProduct = () => {
    setFormData((prev) => ({
      ...prev,
      products: [...prev.products, { product: "", quantity: "" }],
    }));
  };
  // Remove row
  const handleRemoveProduct = (index) => {
    const updatedProducts = [...formData.products];
    updatedProducts.splice(index, 1);
    setFormData((prev) => ({ ...prev, products: updatedProducts }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
        if (!validateForm()) return;
  let reqLines = [];

    setLoading(true);
  // 1. Add VR/AR product-based requirement lines
//   product.forEach(async(p) => {
//      const { id, requirementText } = await autoMatchProduct(p.name, productOptions, p);

// if (requirementText) {
//   setFormData(prev => ({
//     ...prev,
//     requirements: prev.requirements
//       ? prev.requirements + "\n" + requirementText
//       : requirementText
//   }));
// }
//     // if (p.category === "VR Games" || p.category === "AR Games") {
//     //  reqLines.push(`${p.category} - ${p.name}`);
//     // }
//   });

//   // 2. Add user-typed text (if any)
//   if (formData.requirements?.trim()) {
//     reqLines.push(formData.requirements.trim());
//   }
   
    try {
        // --- 1. Loop products and auto-match ---
    for (let i = 0; i < product.length; i++) {
       const p = product[i];
      const match = autoMatchProduct(p.name, productOptions, p,i);

      // match.description is only provided when <70% match or VR/AR
      // if (match.description) {
      //   reqLines.push(match.description);
      // }
    }

    // --- 2. Add user-typed text ---
    // if (formData.requirements?.trim()) {
    //   reqLines.push(formData.requirements.trim());
    // }

      const finalRequirement = reqLines.join("\n");
      const formattedProducts = formData.products.map((item) => {
    return {
      id: item.productId,          // backend id
      label: item.product,         // product name
      amount: String(item.price),  // price ? amount (convert to string IF needed)
      quantity: item.quantity,
      description: item?.description ? item.description :""
    };
  });
   const formattedProductsDB = formData.products.map((item) => {
    return {
      CRM_id: item.productId,          // backend id
      product: item.product,         // product name
      price: item.price,  // price ? amount (convert to string IF needed)
      quantity: item.quantity,
      description: item?.description ? item.description :""
    };
  });
  //console.log("dat",formattedProducts,formattedProductsDB)
      // Prepare data for CRM API
      const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      };
      const bookingData = {
        name: formData.pointOfContact,
        email: userDetails.email,
        phone: formData.contactNumber,
        product_type: formattedProducts,
        event_venue: formData.venueName,
        event_city:
          formData.city === "other" ? formData.otherCity : formData.city,
        event_date: formData.isMultiDay
          ? `${formatDate(formData.startDate)} to ${formatDate(
              formData.endDate
            )}`
          : formatDate(formData.date),
        event_start_time: timeToSeconds(formData.startTime),
        event_end_time: timeToSeconds(formData.endTime),
        message: formData.requirements,
        isMultiDay: formData.isMultiDay,
        companyName: formData.companyName,
        activityArea: formData.activityArea,
        quantity: formData.quantity,
        staff: formData.staff,
        activityType: formData.activityType,
        reportingTime: timeToSeconds(formData.reportingTime),
        venueMapLink: formData.venueMapLink,
        lead_source:"product-catalog page"
      };
       //console.log("bookingData",bookingData)
      // Send to CRM API
      const response = await axios.post(
        "https://bilimbecrm.com/api/v1/enquiry/store",
        bookingData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer I_!1s8` Hp?C9YfpF}[)VQH^=Dv?s#Hzui*bCq;q&yJ[Fb!oy(%jmP7,^zWhs61;", // API key as Authorization Bearer token
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSubmitSuccess(true);
        // Save booking to databaseproduct
        const responsedb = await axiosData.post("createBooking", {
          email: userDetails.email,
          user_id: userDetails._id,
          mobile_number: userDetails.mobile_number,
          items: formattedProductsDB,
          eventDate: bookingData.event_date,
          eventTime: `${formData.startTime} to ${formData.endTime}`,
          eventLocation: bookingData.event_venue,
          totalItems: formData.products.length,
          totalPrice: parseInt(formData.totalPrice),
          name: formData.pointOfContact,
          event_city: bookingData.event_city,
          message: finalRequirement,
          isMultiDay: formData.isMultiDay,
          companyName: formData.companyName,
          activityArea: formData.activityArea,
          quantity: formData.quantity,
          staff: formData.staff,
          activityType: formData.activityType,
          reportingTime: formData.reportingTime,
          venueMapLink: formData.venueMapLink,
        });

        if (responsedb.data) {
          bookMessageSend(userDetails.email,userDetails.mobile_number,bookingData.event_date,`${formData.startTime} to ${formData.endTime}`,bookingData.event_venue,bookingData.event_city)
          onClose();
          // Clear cart after successful booking
          setTimeout(async () => {
            dispatch(clearCart());
            // Also clear from database
            const deleleRes = await axiosData.delete(
              `/deleteCartData/${userDetails.email}`
            );
          }, 10000);
        }
     }
    } catch (error) {
      console.error("Booking submission error:", error);
      setSubmitError(
        error.response?.data?.message ||
          "Failed to submit booking. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    onClose();
    setErrors({});
    setSubmitError("");
  };
 /* Get crm inputs list from api*/
  const fetchCRMinputs = async () => {
    try {
      const data = await axios.post(` https://bilimbecrm.com/api/v1/master/data`);
      if (data) {
        const crmDatas = data.data.data;
         setActivityOptions(crmDatas.activity_types);
         setTimeOptions(crmDatas.times);
        setCityOptions(crmDatas.cities);
        setProductOptions(crmDatas.products)
        const formatted = Object.entries(crmDatas.activity_area).map(([key, value]) => ({
        key,
        label: value
      }));

      setActivityAreaOptions(formatted);
      }
    } catch (err) {
      console.log("Error", err);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        scroll="paper"
        PaperProps={{
          sx: {
            borderRadius: 2,
            background: "#f9fafb",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "white",
            borderBottom: "1px solid #e5e7eb",
            py: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="600">
            Book {product?.produt_name || "Product"}
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <Close />
          </IconButton>
        </DialogTitle>

        <form onSubmit={handleSubmit}>
          <DialogContent
            dividers
            sx={{
              background: "#f9fafb",
              p: 2,
            }}
          >
            <Grid container spacing={3}>
              <Grid container spacing={2}>
                {/* Contact Number */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <TextField
                    fullWidth
                    label="Contact Number *"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleInputChange}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    size="small"
                    sx={{ background: "white" }}
                  />
                </Grid>

                {/* Name */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <TextField
                    fullWidth
                    label="Name *"
                    name="pointOfContact"
                    value={formData.pointOfContact}
                    onChange={handleInputChange}
                    error={!!errors.pointOfContact}
                    helperText={errors.pointOfContact}
                    size="small"
                    sx={{ background: "white" }}
                  />
                </Grid>
                {/* Company Name */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <TextField
                    fullWidth
                    label="Company Name"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    error={!!errors.companyName}
                    helperText={errors.companyName}
                    size="small"
                    sx={{ background: "white" }}
                  />
                </Grid>
                {/* Staff */}
                {/* <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.staff}
                    sx={{ background: "white" }}
                  >
                    <InputLabel>Staff</InputLabel>
                    <Select
                      name="staff"
                      label="Staff"
                      value={formData.staff}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="accounts">Accounts</MenuItem>
                      <MenuItem value="arun kumar">Arun Kumar</MenuItem>
                      <MenuItem value="deepti">Deepti</MenuItem>
                      <MenuItem value="elumalai">Elumalai</MenuItem>
                      <MenuItem value="harsh">Harsh</MenuItem>
                      <MenuItem value="neel">Neel</MenuItem>
                      <MenuItem value="vishnu">Vishnu</MenuItem>
                    </Select>
                    {errors.staff && (
                      <FormHelperText>{errors.staff}</FormHelperText>
                    )}
                  </FormControl>
                </Grid> */}
                {/* City */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.city}
                    sx={{ background: "white" }}
                  >
                    <InputLabel>Select City</InputLabel>
                    <Select
                      name="city"
                      label="Select City"
                      value={formData.city}
                      onChange={handleInputChange}
                    >
                      {cityOptions.map((c) => (
    <MenuItem key={c.id} value={c.label}>
      {c.label}
    </MenuItem>
  ))}
                      {/* <MenuItem value="chennai">Chennai</MenuItem>
                      <MenuItem value="bangalore">Bangalore</MenuItem>
                      <MenuItem value="mumbai">Mumbai</MenuItem>
                      <MenuItem value="delhi">Delhi</MenuItem>
                      <MenuItem value="kolkata">Kolkata</MenuItem>
                      <MenuItem value="hyderabad">Hyderabad</MenuItem>
                      <MenuItem value="pune">Pune</MenuItem>
                      <MenuItem value="goa">Goa</MenuItem>
                      <MenuItem value="coimbatore">Coimbatore</MenuItem>
                      <MenuItem value="cochin">Cochin</MenuItem>
                      <MenuItem value="jaipur">Jaipur</MenuItem>
                      <MenuItem value="Ahamedabad">Ahamedabad</MenuItem>
                      <MenuItem value="madurai">Madurai</MenuItem>
                      <MenuItem value="vellore">Vellore</MenuItem>
                      <MenuItem value="other">Other</MenuItem> */}
                    </Select>
                    {errors.city && (
                      <FormHelperText>{errors.city}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                {/* Enter City if Other */}
                {formData.city === "other" && (
                  <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                    <TextField
                      fullWidth
                      label="Enter City"
                      name="otherCity"
                      value={formData.otherCity}
                      onChange={handleInputChange}
                      size="small"
                      sx={{ background: "white" }}
                    />
                  </Grid>
                )}
                {/* Activity Type */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.activityType}
                    sx={{ background: "white" }}
                  >
                    <InputLabel>What kind of activity</InputLabel>
                    <Select
                      name="activityType"
                      label="What kind of activity"
                      value={formData.activityType}
                      onChange={handleInputChange}
                    >
                      {activityOptions.map((item) => (
      <MenuItem key={item.id} value={item.label}>
        {item.label}
      </MenuItem>
    ))}
                      {/*<MenuItem value="25th/50th wedding anniversary">
                        25th/50th Wedding Anniversary
                      </MenuItem>
                      <MenuItem value="baby shower">Baby Shower</MenuItem>
                      <MenuItem value="baptism">Baptism</MenuItem>
                      <MenuItem value="birthday">Birthday</MenuItem>
                      <MenuItem value="collage / school">
                        Collage / School
                      </MenuItem>
                      <MenuItem value="corporate">Corporate</MenuItem>
                      <MenuItem value="engagement">Engagement</MenuItem>
                      <MenuItem value="exhibition">Exhibition</MenuItem>
                      <MenuItem value="naming ceremony">
                        Naming Ceremony
                      </MenuItem>
                      <MenuItem value="party">Party</MenuItem>
                      <MenuItem value="puberty">Puberty</MenuItem>
                      <MenuItem value="reception">Reception</MenuItem>
                      <MenuItem value="software development">
                        Software Development
                      </MenuItem>
                      <MenuItem value="software support">
                        Software Support
                      </MenuItem>
                      <MenuItem value="wedding">Wedding</MenuItem>*/}
                    </Select>
                    {errors.activityType && (
                      <FormHelperText>{errors.activityType}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Single or Multi Day Date */}
                {!formData.isMultiDay && (
                  <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Date of activity"
                        sx={{
                          width: 268,
                          // "& .MuiPickersSectionList-root": {
                          //   padding: 0,
                          //   height: 40,
                          //   textAlign: "center",
                          // },
                        }}
                        value={formData.date}
                        onChange={(date) =>
                          setFormData((prev) => ({ ...prev, date }))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            size="small"
                            error={!!errors.date}
                            helperText={errors.date}
                            sx={{
                              background: "white",
                              alignItems: "center",
                              "& .MuiInputBase-root": {
                                padding: 1, // Adjust padding if needed,
                                textAlign: "center",
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    <Typography
                      variant="body2"
                      sx={{ color: "red", cursor: "pointer", mt: 1 }}
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          isMultiDay: !prev.isMultiDay,
                        }))
                      }
                    >
                      {formData.isMultiDay
                        ? "Close Multiday"
                        : "For Multi Day Event Click here"}
                    </Typography>
                  </Grid>
                )}
                {formData.isMultiDay && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                          <DatePicker
                            label="Start Date"
                            sx={{ width: 268 }}
                            value={formData.startDate}
                            onChange={(date) =>
                              setFormData((prev) => ({
                                ...prev,
                                startDate: date,
                              }))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                size="small"
                                error={!!errors.startDate}
                                helperText={errors.startDate}
                                sx={{ background: "white" }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                          <DatePicker
                            label="End Date"
                            sx={{ width: 268 }}
                            value={formData.endDate}
                            onChange={(date) =>
                              setFormData((prev) => ({
                                ...prev,
                                endDate: date,
                              }))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                size="small"
                                error={!!errors.endDate}
                                helperText={errors.endDate}
                                sx={{ background: "white" }}
                              />
                            )}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: "red", cursor: "pointer", mt: 1 }}
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                isMultiDay: !prev.isMultiDay,
                              }))
                            }
                          >
                            {formData.isMultiDay
                              ? "Close Multiday"
                              : "For Multi Day Event Click here"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </LocalizationProvider>
                  </Grid>
                )}
                {/* Reporting Time */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.reportingTime}
                    sx={{ background: "white" }}
                  >
                    <InputLabel>Reporting Time</InputLabel>
                    <Select
                      name="reportingTime"
                      label="Reporting Time"
                      value={formData.reportingTime}
                      onChange={handleInputChange}
                    >
                      {timeOptions.map((time) => (
                        <MenuItem key={time.id} value={time.label}>
                          {time.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.reportingTime && (
                      <FormHelperText>{errors.reportingTime}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Activity Start Time */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.startTime}
                    sx={{ background: "white" }}
                  >
                    <InputLabel>Activity Starting Time</InputLabel>
                    <Select
                      name="startTime"
                      value={formData.startTime}
                      label="Activity Starting Time"
                      onChange={handleInputChange}
                    >
                     {timeOptions.map((time) => (
                        <MenuItem key={time.id} value={time.label}>
                          {time.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.startTime && (
                      <FormHelperText>{errors.startTime}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Activity End Time */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.endTime}
                    sx={{ background: "white" }}
                  >
                    <InputLabel>Activity End Time</InputLabel>
                    <Select
                      name="endTime"
                      label="Activity End Time"
                      value={formData.endTime}
                      onChange={handleInputChange}
                    >
                     {timeOptions.map((time) => (
                        <MenuItem key={time.id} value={time.label}>
                          {time.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.endTime && (
                      <FormHelperText>{errors.endTime}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Venue Name */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <TextField
                    fullWidth
                    label="Venue Name"
                    name="venueName"
                    value={formData.venueName}
                    onChange={handleInputChange}
                    error={!!errors.venueName}
                    helperText={errors.venueName}
                    size="small"
                    sx={{ background: "white" }}
                  />
                </Grid>

                {/* Venue Map Link */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <TextField
                    fullWidth
                    label="Venue Map Link"
                    placeholder="Google map link (optional)"
                    name="venueMapLink"
                    value={formData.venueMapLink}
                    onChange={handleInputChange}
                    size="small"
                    sx={{ background: "white" }}
                  />
                </Grid>

                {/* Activity Area */}
                <Grid item xs={12} sm={6} sx={{ width: 268 }}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.activityArea}
                    sx={{ background: "white" }}
                  >
                    <InputLabel>Activity Area</InputLabel>
                    <Select
                      name="activityArea"
                      label="Activity Area"
                      value={formData.activityArea}
                      onChange={handleInputChange}
                    >
                      {activityAreaOptions.map((item) => (
      <MenuItem key={item.key} value={item.label}>
        {item.label}
      </MenuItem>
    ))}

                      {/* <MenuItem value="indoor">Indoor</MenuItem>
                      <MenuItem value="outdoor">Outdoor</MenuItem> */}
                    </Select>
                    {errors.activityArea && (
                      <FormHelperText>{errors.activityArea}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              {/* Product & Quantity Box */}
              {/* <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: "#e5e7ebbc",
                  p: 4,
                  borderRadius: 2,
                  border: " solid #e5e7ebbc",
                }}
              >
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", sm: "row" }}
                  gap={2}
                  alignItems="center"
                  sx={{
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    label="Product"
                    value={formData.product}
                    InputProps={{
                      readOnly: true,
                      sx: { backgroundColor: "#f3f4f6" },
                    }}
                    size="small"
                    sx={{
                      flex: 2,
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f3f4f6",
                      },
                    }}
                  />

                  <FormControl
                    size="small"
                    error={!!errors.quantity}
                    sx={{ background: "white", width: 200 }}
                  >
                    <InputLabel>Quantity</InputLabel>
                    <Select
                      name="quantity"
                      label="Quantity"
                      value={formData.quantity}
                      onChange={handleInputChange}
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.quantity && (
                      <FormHelperText>{errors.quantity}</FormHelperText>
                    )}
                  </FormControl>
                  <Button variant="contained" color="primary">
                    Add
                  </Button>
                </Box>
              </Grid> */}
              {/* Product & Quantity Rows */}
              {formData.products.map((prod, index) => (
                <Grid
                  key={index}
                  item
                  fullWidth
                  xs={12}
                  sx={{
                    backgroundColor: "#e5e7ebbc",
                    p: 3,
                    mb: 2,
                    borderRadius: 2,
                    border: "solid #e5e7ebbc",
                    width: "100%",
                  }}
                >
                  <Box
                    display="flex"
                    flexDirection={{ xs: "column", sm: "row" }}
                    gap={2}
                    alignItems="center"
                    sx={{ justifyContent: "space-between" }}
                  >
                    {/* Product Field */}
                    {/* <TextField
                          label="Product"
                          name="product"
                          value={prod.product}
                          onChange={(e) => handleProductChange(index, e)}
                          InputProps={{
                            sx: { backgroundColor: "#f3f4f6" },
                          }}
                          size="small"
                          sx={{
                            flex: 2,
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "#f3f4f6",
                            },
                          }}
                        /> */}
                    <FormControl fullWidth size="small" sx={{ width: 268 }}>
                      <InputLabel>Product</InputLabel>
                      <Select
 value={prod.productId || ""}
// value={autoMatchProduct(prod.product, productOptions,prod,index).id}
                        // value={
                        //   prod.category === "Virtual Games"
                        //     ? `${prod.product}-Virtual`
                        //     : prod.product
                        // }
                        name="product" 
                        label="Product"
                        onChange={(e) => handleProductChange(index, e)}
                      >
                        {productOptions.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {/* Quantity Selector */}
                    <FormControl
                      size="small"
                      error={!!errors[`products.${index}.quantity`]}
                      sx={{ background: "white", width: 70 }}
                    >
                      <InputLabel>Quantity</InputLabel>
                      <Select
                        name="quantity"
                        label="Quantity"
                        value={prod.quantity}
                        onChange={(e) => handleProductChange(index, e)}
                      >
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                          <MenuItem key={num} value={num}>
                            {num}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors[`products.${index}.quantity`] && (
                        <FormHelperText>
                          {errors[`products.${index}.quantity`]}
                        </FormHelperText>
                      )}
                    </FormControl>

                    {/* Add / Remove Buttons */}
                    <Box display="flex" gap={1}>
                      {index === formData.products.length - 1 && (
                        // <Button
                        //   variant="contained"
                        //   color="primary"
                        //   startIcon={<Add />}
                        //   onClick={handleAddProduct}
                        // >

                        // </Button>
                        <IconButton
                          color="primary"
                          size="medium"
                          onClick={handleAddProduct}
                          sx={{
                            backgroundColor: "#d32f2f",
                            color: "white",
                            "&:hover": { backgroundColor: "#ef2727ff" },
                            borderRadius: "8px",
                          }}
                        >
                          <Add fontSize="medium" />
                        </IconButton>
                      )}
                      {formData.products.length > 1 && (
                        // <Button
                        //   variant="outlined"
                        //   color="error"
                        //   startIcon={<Remove />}
                        //   onClick={() => handleRemoveProduct(index)}
                        // >

                        // </Button>
                        <IconButton
                          color="error"
                          size="medium"
                          onClick={() => handleRemoveProduct(index)}
                          sx={{
                            backgroundColor: "#d32f2f",
                            color: "white",
                            "&:hover": { backgroundColor: "#ef2727ff" },
                            borderRadius: "8px",
                          }}
                        >
                          <Remove fontSize="medium" />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </Grid>
              ))}

              {/* Point of Contact */}
              <Grid
                item
                xs={12}
                sm={6}
                width={700}
                gap={2}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  label="Point of Contact - Name"
                  name="pointOfContact"
                  value={formData.pointOfContact}
                  onChange={handleInputChange}
                  size="small"
                  sx={{ background: "white" }}
                />
                <TextField
                  fullWidth
                  label="Point of Contact - Phone"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleInputChange}
                  size="small"
                  sx={{ background: "white" }}
                />
              </Grid>
              {/* Specific Requirements */}
              <TextField
                fullWidth
                multiline
                rows={5}
                label="Any Specific Requirements"
                placeholder="Message :"
                name="requirements"
                value={formData.requirements}
                onChange={handleInputChange}
                size="small"
                sx={{ background: "white" }}
              />
            </Grid>
          </DialogContent>

          <DialogActions
            sx={{ background: "white", p: 3, borderTop: "1px solid #e5e7eb" }}
          >
            <Button
              type="submit"
              variant="contained"
              sx={{
                background: "#e53935",
                "&:hover": { background: "#c62828" },
                py: 1.5,
                fontWeight: 600,
              }}
            >
              {loading ? <CircularProgress size={24} /> : "Submit"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* <Dialog
        open={submitSuccess}
        aria-labelledby="success-dialog-title"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="success-dialog-title" sx={{ color: "green",display:"flex",alignItems:"center" }}>
          <CheckBoxIcon sx={{fontSize:"25px",marginRight:1}}/><Typography>Success</Typography> 
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Booking submitted successfully!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSubmitSuccess(false)}
            variant="contained"
            color="success"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog> */}
      <Dialog
        open={submitSuccess}
        aria-labelledby="success-dialog-title"
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 10px 30px rgba(244, 67, 54, 0.2)",
          },
        }}
      >
        <DialogContent sx={{ p: 4, textAlign: "center" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #ff5252 0%, #d32f2f 100%)",
                borderRadius: "50%",
                width: 90,
                height: 90,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 15px rgba(211, 47, 47, 0.3)",
              }}
            >
              <CheckBoxIcon sx={{ fontSize: "45px", color: "white" }} />
            </Box>
          </Box>

          <Typography
            variant="h5"
            sx={{ mb: 2, fontWeight: "bold", color: "#d32f2f" }}
          >
            Booking Received!
          </Typography>

          <Typography
            variant="body1"
            sx={{ mb: 2, color: "text.primary", fontSize: "1.1rem" }}
          >
            Your booking request has been submitted successfully.
          </Typography>

          <Box
            sx={{
              backgroundColor: "#ffebee",
              borderRadius: 2,
              p: 2,
              border: "1px solid #ffcdd2",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#d32f2f",
                fontWeight: "600",
                textAlign: "center",
                lineHeight: 1.6,
              }}
            >
              Our team will contact you shortly to confirm your booking details.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 4, px: 4 }}>
          <Button
            onClick={() => setSubmitSuccess(false)}
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #ff5252 0%, #d32f2f 100%)",
              color: "white",
              minWidth: 140,
              py: 1.2,
              borderRadius: 2,
              fontWeight: "bold",
              fontSize: "1rem",
              boxShadow: "0 4px 12px rgba(211, 47, 47, 0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)",
                boxShadow: "0 6px 16px rgba(211, 47, 47, 0.4)",
              },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={!!submitError}
        onClose={() => setSubmitError("")}
        aria-labelledby="success-dialog-title"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="success-dialog-title" sx={{ color: "error" }}>
          Failed
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">{submitError}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSubmitError("")}
            variant="contained"
            color="error"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BookingForm;
